import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { ErrorOutline, Inbox } from '@mui/icons-material';
import Button from './Button';
import { COLOR } from './tokens';

const wrapSx = {
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    textAlign: 'center',
    color: COLOR.textMuted,
};

export function LoadingState({ label = 'Loading…', compact = false }) {
    return (
        <Box role="status" data-testid="state-loading" sx={wrapSx}>
            {compact ? null : <CircularProgress size={24} sx={{ color: COLOR.primary }} />}
            <Typography variant="body2">{label}</Typography>
        </Box>
    );
}

export function EmptyState({ hint, message, icon = true }) {
    const text = hint || message || 'Nothing here yet.';
    return (
        <Box data-testid="state-empty" sx={wrapSx}>
            {icon ? <Inbox sx={{ color: COLOR.textSubtle }} /> : null}
            <Typography variant="body2">{text}</Typography>
        </Box>
    );
}

export function ErrorState({ title, message = 'Something went wrong.', onRetry }) {
    return (
        <Box role="alert" data-testid="state-error" sx={wrapSx}>
            <ErrorOutline sx={{ color: COLOR.danger }} />
            {title ? (
                <Typography sx={{ color: COLOR.text, fontWeight: 700 }}>{title}</Typography>
            ) : null}
            <Typography variant="body2" sx={{ color: title ? COLOR.textMuted : COLOR.text }}>{message}</Typography>
            {onRetry ? (
                <Button size="sm" variant="secondary" onClick={onRetry}>Try again</Button>
            ) : null}
        </Box>
    );
}
